import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import type { SourceTypeChipProps } from '../types';

/**
 * SourceTypeChip - Display source type (SAP vs Custom)
 *
 * Pure presentational component that shows whether a document
 * is from SAP (primary color) or custom uploaded (default color).
 *
 * @param sourceType - The source type string (optional)
 * @param isSap - Whether the document is from SAP
 */
export const SourceTypeChip: React.FC<SourceTypeChipProps> = ({ sourceType, isSap }) => {
  const { t } = useTranslation();

  return (
    <Chip
      label={isSap ? t('documents.table.sap') : t('documents.table.custom')}
      color={isSap ? 'primary' : 'default'}
      size="small"
    />
  );
};

SourceTypeChip.displayName = 'SourceTypeChip';
